<div class="flex-row align-items-center">
  <!-- Unlimited storage: animated dots -->
  <div *ngIf="isUnlimited" class="dots-container">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>

  <!-- Limited storage: progress bar -->
  <div *ngIf="!isUnlimited" class="progress-bar">
    <div class="progress-fill" [style.width.%]="usedPercentage"></div>
  </div>

  <span class="text-nowrap storage-indicator" [matTooltip]="usedStorage" [matTooltipShowDelay]="TOOLTIP_SHOW_DELAY">
    <ng-container *ngIf="!isUnlimited; else unlimited">
      {{ usedStorageOutOfTotal }}
    </ng-container>
    <ng-template #unlimited> {{ usedStorage }} / ∞ </ng-template>
  </span>
</div>
